const CART_DRAWER_SELECTOR = 'cart-drawer-component';
const RETRY_INTERVAL = 25;
const RETRY_TIMEOUT = 5000;

let configured = false;
let retryStartedAt = 0;
let retryTimer;

function getCartEventTarget() {
  return document.querySelector(CART_DRAWER_SELECTOR) ?? document;
}

function init() {
  if (configured) return true;

  const actions = window.Shopify?.actions;
  if (!actions?.updateCart?.configure || !actions.openCart?.configure) return false;

  actions.updateCart.configure({
    eventTarget: getCartEventTarget,
    async handler(defaultHandler) {
      return defaultHandler();
    },
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & { open?: () => void } | null} */
      const drawer = document.querySelector(CART_DRAWER_SELECTOR);

      if (typeof drawer?.open === 'function') {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });

  configured = true;
  if (retryTimer) window.clearTimeout(retryTimer);
  return true;
}

function initWhenReady() {
  if (init()) return;

  retryStartedAt ||= Date.now();
  if (Date.now() - retryStartedAt >= RETRY_TIMEOUT) {
    console.warn('Shopify standard actions were not available before the configuration timeout.');
    return;
  }

  retryTimer = window.setTimeout(initWhenReady, RETRY_INTERVAL);
}

initWhenReady();
window.CHStandardActions = Object.freeze({ configure: initWhenReady });
window.dispatchEvent(new CustomEvent('ch:standard-actions-ready'));
window.addEventListener('load', initWhenReady, { once: true });
